$(document).on('turbo:load turbo:render dynamicSubheaderAdded', () => {


    $(".dynamic-subheader-field").each((i, el) =>{
        let $el = $(el);

        $el.on("change", (e) =>{
            // @ts-ignore
            let value = e.currentTarget.value;
            if (value == ""){
                value = "Expand to View"
            }
            let $element = $(e.currentTarget);
            let $card = $element.closest(".card");
            $card.find(".dynamic-sub-header").html(value);

        })
    })
});